import React, { useState } from "react";
import "./project6.css";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";

function Project6() {
  const [main, setMain] = useState(false);
  const gotoMainPage = () => {
    setMain(true);
  };

  return (
    <>
      {!main ? (
        <div className="body">
          <div className="headerP1">
            <h2 id="Title">Spotify Stats</h2>
            <div id="P1Github">
              <a
                href="https://github.com/AkhilTheBoss/Shell"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="secondary">Github</Button>
              </a>
            </div>
            <div id="mainPage">
              <Button variant="primary" onClick={gotoMainPage}>
                Main Page
              </Button>
            </div>
          </div>
          <br />
        </div>
      ) : (
        <App />
      )}
    </>
  );
}

export default Project6;
